import { LocalTime } from "@js-joda/core";
export default class Timeslot {
    id = 0;
    weekdays = [];
    startTime;
    endTime;
    resourceOccupationStart;
    resourceOccupationEnd;
    constructor() {
        this.startTime = LocalTime.now().withSecond(0);
        this.endTime = LocalTime.now().withSecond(0);
        this.resourceOccupationStart = this.startTime;
        this.resourceOccupationEnd = this.endTime;
    }
    assign(other) {
        this.id = other.id;
        this.weekdays = [...other.weekdays];
        this.startTime = LocalTime.parse(other.startTime.toString());
        this.endTime = LocalTime.parse(other.endTime.toString());
        this.resourceOccupationStart = LocalTime.parse(other.resourceOccupationStart.toString());
        this.resourceOccupationEnd = LocalTime.parse(other.resourceOccupationEnd.toString());
    }
}
